import React from 'react';
import { useTranslation } from 'react-i18next';
import TzamunAiIcon from './TzamunAiIcon';

/** Small TzamunAI mark beside a label whose value was read off a scanned invoice. */
export function ScanMark() {
  const { t } = useTranslation();
  const label = t('purchases.scan.missing.readFromInvoice', { defaultValue: 'Read from the invoice' });
  return (
    <span className="inline-flex align-middle ms-1" title={label} aria-label={label} role="img">
      <TzamunAiIcon size={13} />
    </span>
  );
}

export default function FormField({
  label,
  htmlFor,
  error,
  hint,
  required = false,
  fromScan = false,
  disabled = false,
  className = '',
  children,
}) {
  const content = disabled ? (
    <fieldset disabled={disabled} className="contents border-0 p-0 m-0 min-w-0">
      {children}
    </fieldset>
  ) : (
    children
  );

  return (
    <div className={`text-start ${className}`}>
      {label && (
        <label htmlFor={htmlFor} className="block text-sm font-medium text-content-secondary mb-1.5">
          {label}
          {fromScan && <ScanMark />}
          {required && <span className="text-red-500 ms-1">*</span>}
        </label>
      )}
      {content}
      {error ? (
        <p className="mt-1.5 text-xs text-red-600 dark:text-red-400">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-content-muted">{hint}</p>
      ) : null}
    </div>
  );
}
